'use client';

import { useEffect } from 'react';

const SECTION_IDS = ['why-soft-water', 'how-it-works', 'calculator', 'contact'];

export default function RouteBeacon() {
  useEffect(() => {
    // Notify parent on first paint
    postMessageSafe({ type: 'wet:route', path: location.pathname, hash: location.hash });

    const onHash = () => {
      postMessageSafe({ type: 'wet:set-hash', hash: location.hash });
      postMessageSafe({ type: 'wet:route', path: location.pathname, hash: location.hash });
    };
    window.addEventListener('hashchange', onHash);

    // Intersection to emit section hits (optional GA event upstream)
    const io = new IntersectionObserver(
      (entries) => {
        const top = entries.find((e) => e.isIntersecting);
        if (top?.target?.id) {
          const h = `#${top.target.id}`;
          history.replaceState(null, '', h);
          postMessageSafe({ type: 'wet:set-hash', hash: h });
          postMessageSafe({ type: 'wet:route', path: location.pathname, hash: h });
        }
      },
      { rootMargin: '0px 0px -65% 0px', threshold: 0.1 }
    );
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) io.observe(el);
    });

    return () => {
      window.removeEventListener('hashchange', onHash);
      io.disconnect();
    };
  }, []);

  // Delegate on-page nav clicks
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const a = (e.target as HTMLElement)?.closest?.('a[href^="#"]') as HTMLAnchorElement | null;
      if (!a) return;
      const href = a.getAttribute('href') || '';
      const id = href.replace(/^#/, '');
      if (!id) return;

      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const h = `#${id}`;
        history.pushState(null, '', h);
        postMessageSafe({ type: 'wet:set-hash', hash: h });
        postMessageSafe({ type: 'wet:route', path: location.pathname, hash: h });
      }
    };
    document.addEventListener('click', onClick, { capture: true });
    return () => document.removeEventListener('click', onClick, { capture: true } as any);
  }, []);

  return null;
}

function postMessageSafe(payload: unknown) {
  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(payload, '*');
    }
  } catch {}
}
